import { takeEvery, fork, put, all, call } from "redux-saga/effects"
import { VERIFY_OTP, SEND_MOBILE, SEND_FORGETPASSMOBILENO, CHANGE_PASSWORD_START, CHANGE_PROFILE_PASSWORD_START } from "./actionTypes"
import {
  verifyOtpSuccessful,
  verifyOtpFailed,
  sendMobileSuccessful,
  sendMobileFailed,
  sendForgetPassmobnoFailed,
  sendForgetPassmobnoSuccessful,
  ChangePasswordSuccess,
  ChangePasswordFailure,
  ChangeProfilePasswordSuccess,
  ChangeProfilePasswordFailure,
} from "./action"
import { verifyOTPAPI, sendPhoneAPI, sendForgetPassMobnoAPI, ForgetPasswordAPI, ChangeProfilePasswordAPI } from "./api"
import { userForgetPasswordSuccess } from "../forgetpwd/actions"

function* sendPhoneAsync(payload) {
  try {
   
    const response = yield call(sendPhoneAPI, payload)
    if(response.status === 200){
      yield put(sendMobileSuccessful(response.data))
    }else{
      throw new Error(response)
    }
   
  } catch (error) {
    yield put(sendMobileFailed(error.response.data.message))
  }
}

export function* sendPhone() {
  yield takeEvery(SEND_MOBILE, sendPhoneAsync)
}

function* verifyOtpAsync(payload) {
    console.log("verifying OTP saga")
    try {
      console.log("Trying to verifying OTP (within try block)")
      const response = yield call(verifyOTPAPI, payload)
      if(response.status === 200){
        yield put(verifyOtpSuccessful(response.data))
      }else{
        throw new Error(response);
      } 
    } catch (error) {
      console.log("There was an error send phone no: ", error.message)
      yield put(verifyOtpFailed(error.response.data.message))
    }
  }
  
  export function* verifyOtp() {
    yield takeEvery(VERIFY_OTP, verifyOtpAsync)
  }



  function* sendForgetPassMobnoAsync(payload) {
    try {
     
      const response = yield call(sendForgetPassMobnoAPI
        
        , payload)
      if(response.status === 200){
        yield put(sendForgetPassmobnoSuccessful(response.data))
      }else{
        throw new Error(response)
      }
     
    } catch (error) {
      yield put(sendForgetPassmobnoFailed(error.response.data.message))
    }
  }
  
  export function* sendForgetPassmobnosaga() {
    yield takeEvery(SEND_FORGETPASSMOBILENO, sendForgetPassMobnoAsync)
  }



  function* ForgetPasswordAsync(payload) {
    try {
     
      const response = yield call(ForgetPasswordAPI
        
        , payload)
      if(response.status === 200){
        yield put(ChangePasswordSuccess(response.data))
      }else{
        throw new Error(response)
      }
     
    } catch (error) {
      yield put(ChangePasswordFailure(error.response))
    }
  }
  
  export function* changePasswordsaga() {
    yield takeEvery(CHANGE_PASSWORD_START, ForgetPasswordAsync)
  }


  function* ChangeProfilePasswordAsync(payload) {
    try {
     
      const response = yield call(ChangeProfilePasswordAPI
        
        , payload)
      if(response.status === 200){
        yield put(ChangeProfilePasswordSuccess(response.data))
      }else{
        throw new Error(response.data.message)
      }
     
    } catch (error) {
      yield put(ChangeProfilePasswordFailure(error.response.data.message))
    }
  }
  
  export function* changeProfilePasswordsaga() {
    yield takeEvery(CHANGE_PROFILE_PASSWORD_START, ChangeProfilePasswordAsync)
  }



  function* verifyOtpSaga() {
    yield all([
      fork(sendPhone),
      fork(sendForgetPassmobnosaga),
       fork(verifyOtp),
       fork(changePasswordsaga),
       fork(changeProfilePasswordsaga),
      ])
  }
  
  export default verifyOtpSaga